import React from 'react'
import { Create } from 'react-admin'
import { STANDARD_PRICING_STARTUP } from 'services/cfg/form'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import FoodUpsellingForm from './FoodUpsellingForm'

const FoodUpsellingCreate: React.FC = () => {
  return (
    <SectionWrapper>
      <Create record={{ pricing: STANDARD_PRICING_STARTUP }}>
        <FoodUpsellingForm />
      </Create>
    </SectionWrapper>
  )
}

export default FoodUpsellingCreate
